import { Wrapper, Circle, Info } from "./styled";

const LoadingScreen = () => (
  <Wrapper>
    <Info>LOADING QUESTIONS</Info>
    <Circle></Circle>
  </Wrapper>
);

export default LoadingScreen;
